/* My Instruments */

jQuery(document).ready(function($) {

	$(".c-instrument--title").on("click", function() {
		$(this).closest(".c-instrument").toggleClass("active");
	});

	$(".c-instrument--actions__drop").on("click", function() {
		$(this).closest(".c-instrument").toggleClass("active");
	});

});

//jQuery('.c-instrument--check input[type=checkbox]').on('change', function () {
//	var len = jQuery('.c-instrument--check input[type=checkbox]:checked').length;
//	if (len > 0) {
		
//			$(".c-page-header .c-btn").removeClass("disable");
//			$(".c-page-header .c-btn").addClass("c-btn__primary--outline");
//	} else {
		
//			$(".c-page-header .c-btn").addClass("disable");
//			$(".c-page-header .c-btn").removeClass("c-btn__primary--outline");
//	}
//}).trigger('change');
